export const QuestionnaireTemplateVersionStatus = {
  Archived: 'archived',
  Draft: 'draft',
  Published: 'published',
} as const;

export type QuestionnaireTemplateVersionStatus =
  (typeof QuestionnaireTemplateVersionStatus)[keyof typeof QuestionnaireTemplateVersionStatus];
